<script>
  import {onMount} from 'svelte';
  import {url} from '@sveltech/routify';

  import Loading from "../../Components/UI/Loading.svelte";
  import Error from "../../Components/UI/Error.svelte";
  import Boton from "../../Components/UI/Boton.svelte";
  import Titulo from "../../Components/UI/Titulo.svelte";
  import ArbolDeGrupos from '../../Components/Grupos/Arbol/index.svelte';

  import store from '../../Stores/grupos-store';
  import Modal from "../../Components/UI/Modal.svelte";
  import Icono from "../../Components/UI/Icono.svelte";

  onMount(() => store.cargar());
  $: error = $store.error;

  let grupoEliminado, errorEliminacion;
  $: grupoEliminado = $store.grupoEliminando;
  $: errorEliminacion = $store.errorEliminacion;

  const eliminarGrupo = e => store.eliminarGrupo(e.detail);
  const eliminaGrupoDeVerdad = () => store.eliminaGrupoDeVerdad(grupoEliminado);

  let activos = true;

  $: grupos = $store.listado;
</script>

<style>
    .nuevo-grupo {
        margin: var(--padding-global) 0;
    }

    label {
        margin-left: .5em;
    }

    label:not(:last-child) {
        margin-right: 1em;
    }
</style>

<svelte:head>
    <title>Grupos</title>
</svelte:head>

<Titulo>Grupos</Titulo>

{#if $store.cargando }
    <Loading/>
{/if}

{#if error}
    <Error on:cancel={() => error = false}>{$store.error}</Error>
{/if}

{#if grupos.length }
    <ArbolDeGrupos on:eliminar-grupo={eliminarGrupo} {grupos}/>
{/if}

<div class="nuevo-grupo">
    <Boton href="{$url('../nuevo')}">Nuevo grupo</Boton>
</div>

{#if grupoEliminado}
    <Modal title="¿Está seguro de que desea eliminar el grupo {grupoEliminado.nombre}?"
           error={errorEliminacion}>
        <div slot="footer" class="opciones">
            <Boton on:click={eliminaGrupoDeVerdad} grupo="peligro">
                <Icono>check</Icono>
                Confirmar
            </Boton>
            <Boton on:click={() => grupoEliminado = false} grupo="neutral">
                <Icono>cancel</Icono>
                Cancelar
            </Boton>
        </div>
    </Modal>
{/if}